import React, { useEffect, useState, useRef } from 'react';
import Slider from 'react-slick';
import './Clients.css';

const sliderSettings = {
  infinite: true,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 600,
  slidesToShow: 6,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  pauseOnHover: true,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 4 } },
    { breakpoint: 768, settings: { slidesToShow: 3 } },
    { breakpoint: 480, settings: { slidesToShow: 2 } },
  ],
};

const Clients = () => {
  const sliderRef = useRef(null);
  const [organizationsData, setOrganizationsData] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/home-page`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": `${process.env.REACT_APP_API_URL_USERNAME}`,
        "api-password": `${process.env.REACT_APP_API_URL_PASSWORD}`
      },
      body: JSON.stringify({})
    })
      .then((response) => response.json())
      .then((data) => {
        setOrganizationsData(data.organizations);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <section className="clients-section" id="clients">
      <div className="container-fluid">
        <div className="clients-inner">
          {/* Heading */}
          <div className="clients-heading" data-aos="fade-up">
            <p className="clients-tagline">
              Trusted by organizations across industries
            </p>
          </div>

          {/* Logo Carousel */}
          <div data-aos="fade-up" data-aos-delay="100">
            <Slider {...sliderSettings} ref={sliderRef} className="clients-carousel">
              {organizationsData.map((client, i) => (
                <div className="client-logo-item" key={i}>
                  <div className="client-logo-card">
                    {/* Changed client.name to 'client-logo' */}
                    <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${client.folder_path}/${client.image}`} alt={`client-logo-${i}`} className="client-logo-img" />
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          <p className="clients-legal-note" data-aos="fade-up" data-aos-delay="140">
            Selected organizations where our consultants have contributed to transformation initiatives. Logos used for reference only.
          </p>
        </div>
      </div>
    </section>
  );
};


export default Clients;
